// extracted by mini-css-extract-plugin
export var chevronIcon = "_br-2";
export var teamName = "_br-1";
export var teamSwitcherButton = "_br-0";